<template>
	<fragment>
		<GeminiScrollbar class="rht-view my-scroll-bar alloc-my-scrollbar">
			<div
				class="table-container"
				:style="{width: `${masterTableWidth}px`, minWidth: `${masterTableWidth}px`}"
				:class="(allocations.length == 0)? 'empty-view':'filled-view'"
			>
				<scroll-sync group="report" vertical>
					<div class="master-head" ref="masterHeadScroll">
						<!--Loop through the allocation data to set the month-year header-->
						<template v-for="(allocation,index) in allocations">
							<div class="master-head-month" :key="index">
								<h3 class="month-name">{{allocation.monthNameAndYear}}</h3>
							</div>
						</template>
					</div>
					<div class="table-wrapper">
						<div class="master-table-head-box">
							<div
								class="each-month each-month-header"
								:key="index"
								v-for="(allocation,index) in allocations"
							>
								<div class="master-table-head mh-days">
									<div>
										<div class="master-table-text right-table-header">Days</div>
									</div>
								</div>
								<div class="master-table-head mh-vac">
									<div>
										<div class="master-table-text right-table-header vac">Vac.</div>
									</div>
								</div>
								<div class="master-table-head mh-sick">
									<div>
										<div class="master-table-text right-table-header sick">Sick</div>
									</div>
								</div>
								<div class="master-table-head mh-other">
									<div>
										<div class="master-table-text right-table-header other">Other</div>
									</div>
								</div>
								<div class="master-table-head mh-act">
									<div>
										<div class="master-table-text right-table-header act">Act.</div>
									</div>
								</div>
								<div class="master-table-head mh-tv">
									<div>
										<div class="master-table-text right-table-header tv">Workload</div>
									</div>
								</div>
							</div>
						</div>
						<div
							class="master-table report-master-table-set inner-master-table"
							:style="{width: `${masterTableWidth}px`, minWidth: `${masterTableWidth }px`}"
							v-bar
						>
							<scroll-sync group="one" vertical>
								<div class="master-table" ref="masterTableRight" :class="loaderClass">
									<div
										class="each-month"
										v-for="(allocation,allocationIndex) in allocations"
										:key="allocationIndex"
										ref="allocationRow"
									>
										<div class="month-table consultant-workload-sep">
											<template v-for="(monthlyAllocation,index) in allocation.consultantsEngagementsList">
												<consultant-workload-allocation-month
													:monthlyAllocation="monthlyAllocation"
													:key="allocationIndex+'_'+index"
												/>
											</template>
										</div>
									</div>
								</div>
							</scroll-sync>
						</div>
					</div>
				</scroll-sync>
				<!-- Report -->
				<div class="month-report-bottom">
					<div class="report-left-list">
						<div class="month-report-bottom-inner">
							<div v-for="(result,index) in results" class="each-month each-moth-bottom" :key="index">
								<div class="month-table single-flex-row single-flex-wrap">
									<work-load-result :result="result.internal" />
									<work-load-result :result="result.external" />
									<work-load-result :result="result.total" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</GeminiScrollbar>
	</fragment>
</template>

<script>
    import WorkLoadResult from "./WorkLoadResult";

    const ConsultantWorkloadAllocationMonth = () =>
        import("./ConsultantworkloadAllocationMonth");

    export default {
        name: "ConsultantworkloadAllocation",
        components: {WorkLoadResult, ConsultantWorkloadAllocationMonth},
        data() {
            return {
                masterTableWidth: 0,
                masterTableFinalWidth: 0,
                monthTableWidth: 0,
                isDomReady: false,
                allocationLength: 0,
                loaderClass: ""
            };
        },
        computed: {
            /**
             * Allocation data from store
             */
            allocations: function () {
                return this.$store.state.reports.consultantWorkloadAllocations;
            },
            results: function () {
                return this.$store.state.reports.consultantWorkloadResult;
            }
        },
        updated() {
            this.setTableWidth();
            this.updateLoader();
        },
        created() {
            // Hiding the loader once the component is created
            this.isDomReady = true;
            this.updateLoader();
        },
        mounted() {
            this.setTablePadding();
            setTimeout(() => {
                this.HeadHorizontalScroll();
            }, 500);
        },
        methods: {
            /**
             * Set the width after the data load
             */
            setTableWidth: function () {
                //Adding actual width
                this.masterTableWidth = 333.66 * this.allocations.length + 10;
            },
            setTablePadding: function () {
                setTimeout(() => {
                    this.masterTableWidth += 100;
                }, 800);
            },
            /**
             * Set the loader class on all component loaded
             */
            updateLoader: function () {
                setTimeout(() => {
                    if (
                        typeof this.$refs.allocationRow !== "undefined" &&
                        this.$refs.allocationRow.length === this.allocations.length
                    ) {
                        this.loaderClass = "master-table-loaded";
                    }
                }, 200);
            },

            HeadHorizontalScroll: function () {
                let ScrollElement = this.$refs.masterHeadScroll,
                    scrollableElement = document.querySelector(
                        ".alloc-my-scrollbar .gm-scroll-view"
                    ),
                    i = 0;

                ScrollElement.addEventListener("wheel", function (e) {
                    //When dragging to left side
                    if (e.deltaY < 0 && !e.shiftKey) {
                        if (i >= 0) {
                            //if Scroll left == 0
                            scrollableElement.scrollLeft = i;
                            i = i - 50;
                        } else {
                            i = 0;
                        }
                    }

                    //Mouse wheel and horizontal scroll for allocation's headers
                    else if (e.deltaY > 0 && !e.shiftKey) {
                        if (i <= scrollableElement.scrollWidth) {
                            //if Scroll left !== end of the div
                            scrollableElement.scrollLeft = i;
                            i = i + 50;
                        } else {
                            i = scrollableElement.scrollWidth;
                        }
                    }
                });
            }
        },
        watch: {
            /**
             * Watch if the allocation data is fetch
             */
            allocations: function () {
                // call the function after the allocation data is loaded
                this.setTableWidth();
            }
        }
    };
</script>

<style scoped>
	.td-element-center {
		text-align: center;
		width: 23px;
		display: inline-block;
		margin: 0 auto;
	}

	.tv .td-element-center {
		width: 55px;
		text-align: right;
	}

	.mh-other .td-element-center {
		width: 34px;
	}

	.my-scroll-bar {
		/* height: 780px; */
		/* overflow-y: hidden; */
	}

	.my-scroll-bar.gm-scrollbar-container .gm-scroll-view {
		overflow-y: hidden !important;
	}

	.each-month-header .mh-days,
	.month-table .mh-days {
		min-width: 62px;
		max-width: 62px;
		width: 62px;
		padding-left: 16px;
	}

	.each-month-header .mh-vac,
	.month-table .mh-vac {
		min-width: 44px;
		max-width: 44px;
		width: 44px;
	}

	.each-month-header .mh-sick,
	.month-table .mh-sick {
		min-width: 44px;
		max-width: 44px;
		width: 44px;
	}

	.each-month-header .mh-other,
	.month-table .mh-other {
		min-width: 50px;
		max-width: 50px;
		width: 50px;
	}

	.each-month-header .mh-act,
	.month-table .mh-act {
		min-width: 42px;
		max-width: 42px;
		width: 42px;
	}

	.each-month-header .mh-tv,
	.month-table .mh-tv {
		min-width: 70px;
		max-width: 70px;
		width: 70px;
	}

	.each-month,
	.master-head-month {
		border-right: 1px solid #eef0f1;
	}

	.each-month tr > .right-td {
		padding-top: 0 !important;
		padding-bottom: 13px !important;
	}

	.each-month tr:first-of-type > .right-td {
		padding-top: 25px !important;
	}

	/* Master table on consulant workload */
	.master-table {
		max-height: calc(100vh - 310px);
		min-height: calc(100vh - 310px);
		height: calc(100vh - 310px);
	}

	.month-report-bottom,
	.month-report-bottom-inner {
		/* height: auto;
			min-height: auto;
			max-height: auto; */
	}

	.left-days-cell-i {
		text-align: center;
	}

	/* month report bottom  */
	.month-report-bottom {
		/* padding-top: 16px !important; */
	}

	.each-moth-bottom .single-full:last-child,
	.each-moth-bottom > .month-table {
		border-bottom: none !important;
	}

	.month-report-bottom::-webkit-scrollbar {
		width: 0 !important;
	}

	.month-report-bottom {
		overflow: -moz-scrollbars-none;
	}

	.month-report-bottom {
		-ms-overflow-style: none;
	}

	/* New styles */
	.each-month-header .mh-act .right-table-header,
	.each-month-header .mh-other .right-table-header,
	.each-month-header .mh-sick .right-table-header,
	.each-month-header .mh-vac .right-table-header {
		text-align: center;
	}
</style>
